import pino from 'pino';

const logger = pino({
  serializers: {
    err: pino.stdSerializers.err,
    error: pino.stdSerializers.err,
  },
});

function processData(levelName, message, data) {
  return { levelName, message, ...data };
}

function logInfo(message, data) {
  logger.info(processData('INFO', message, data));
}

function logWarn(message, data) {
  logger.warn(processData('WARNING', message, data));
}

function logError(message, data) {
  logger.error(processData('ERROR', message, data));
}

export { logInfo, logWarn, logError };
